import React from 'react';
import Modal from '../../Atoms/Modal/Modal';
import deleteIcon from '../../../assets/Imagess/caution.svg';
import Buttons from '../../Atoms/Buttons/Buttons';
import styles from '../../Atoms/Modal/Modal.module.scss';
import Loader from '../Loader/Loader';
import LoaderButton from '../Loader/LoaderButton';

const DeletePopup = ({
  handleOnClose,
  title,
  handleDelete,
  isLoading,
  selectedItem,
}) => {
  return (
    <Modal onClose={handleOnClose} closeWhite={false}>
      <div className={styles['delete-container']}>
        <img src={deleteIcon} />
        <h3> {'حذف' + ' ' + title}</h3>
        <p> {'هل تريد حذف هذا' + ' ' + title + ' ' + '?'}</p>

        {isLoading ? (
          <LoaderButton />
        ) : (
          <div className={styles['button-input-container']}>
            <Buttons
              text="إلغاء"
              color="#D9D9D9"
              handleOnClick={handleOnClose}
              rounded
              width={250}
            />{' '}
            <Buttons
              text="حذف"
              color="#D72222"
              handleOnClick={() => handleDelete(selectedItem)}
              rounded
              width={250}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default DeletePopup;
